import { Map } from 'immutable';
import { constants as authConstants } from '@saucelabs/sl-container-authentication';

import * as constants from './constants';

const initialState = Map({
  initialized: false,
  unauthenticated: false,
  errorCode: undefined,
});

const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.INITIALIZED:
      return state.set('initialized', true);
    case authConstants.LOGIN.SUCCESS:
      return state.set('unauthenticated', false);
    case authConstants.LOGOUT.SUCCESS:
      return state.set('unauthenticated', true);
    case authConstants.WHOAMI_JWT_GET.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('unauthenticated', true)
          .set('errorCode', payload?.response?.status);
      });
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default appReducer;
export { initialState };
